<template>
  <div class="product-details-services">
    <div
      class="product-details-services__service"
      v-for="(service, index) in services"
      :key="`service-${index}`"
    >
      <component
        v-if="service.icon"
        :is="service.icon"
        class="product-details-services__service__icon"
      />
      <div
        v-if="service.label"
        class="product-details-services__service__label"
      >
        {{ $t(service.label) }}
      </div>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent } from '@nuxtjs/composition-api';
import {
  SecurePaymentsIcon,
  FreeShippingIcon,
  InsuredExpressCourierIcon,
  GenuineHandmadeGlassIcon,
  CertificateOfAuthenticityIcon,
  MadeInItalyIcon,
} from '~/components/General/Icons';
import { useMarkets } from '~/composables';

export default defineComponent({
  name: 'ProductDetailsServices',
  components: {
    SecurePaymentsIcon,
    FreeShippingIcon,
    InsuredExpressCourierIcon,
    GenuineHandmadeGlassIcon,
    CertificateOfAuthenticityIcon,
    MadeInItalyIcon,
  },
  setup() {
    const { isUeMarket } = useMarkets();

    const services = computed(() => [
      {
        icon: 'SecurePaymentsIcon',
        label: 'Secure payments',
      },
      {
        icon: 'FreeShippingIcon',
        label: isUeMarket.value ? 'Free shipping' : 'Super Safe Packaging',
      },
      {
        icon: 'InsuredExpressCourierIcon',
        label: 'Insured express courier',
      },
      {
        icon: 'GenuineHandmadeGlassIcon',
        label: 'Genuine handmade glass',
      },
      {
        icon: 'CertificateOfAuthenticityIcon',
        label: 'Certificate of authenticity',
      },
      {
        icon: 'MadeInItalyIcon',
        label: 'Made in Italy',
      },
    ]);

    return {
      services,
    };
  },
});
</script>

<style lang="scss" scoped>
.product-details-services {
  &__service {
    display: flex;
    align-items: center;
    min-height: 2.5rem;
    &:not(:last-child) {
      margin-bottom: 1rem;
    }
    &__icon {
      position: absolute;
    }
    &__label {
      margin-left: 3rem;
      @include paragraph-m;
    }
  }
}
</style>
